import { render, staticRenderFns } from "./small_fwd.vue?vue&type=template&id=da1ce79e&scoped=true&"
import script from "./small_fwd.vue?vue&type=script&lang=js&"
export * from "./small_fwd.vue?vue&type=script&lang=js&"
import style0 from "./small_fwd.vue?vue&type=style&index=0&id=da1ce79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ce79e",
  null
  
)

export default component.exports